module.exports = __webpack_public_path__ + "static/media/Facebook.d964c805.png";